"use strict";
/*
 * Created on 19. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../core/utils");

var KpiEngineEnum_1 = require("./KpiEngineEnum"); // tslint:disable-next-line:no-namespace


var KpiSetSpec;

(function (KpiSetSpec) {
  function isObjectWithId(spec) {
    if (!utils_1.Utils.isArray(spec)) {
      throw new Error('Spec is always an array');
    }

    if (spec.length !== 2 && spec.length !== 3) {
      throw new Error('Spec bad length');
    }

    return spec.length === 2 && utils_1.Utils.isString(spec[0].id);
  }

  KpiSetSpec.isObjectWithId = isObjectWithId;

  function expandKpiSpec(spec) {
    if (isObjectWithId(spec)) {
      return [spec[0].constructor.name, spec[0].id, spec[1]];
    } else {
      return spec;
    }
  }

  KpiSetSpec.expandKpiSpec = expandKpiSpec;

  function specToString(spec) {
    var espec = expandKpiSpec(spec);
    return espec[0] + '-' + espec[1] + '-' + espec[2];
  }

  KpiSetSpec.specToString = specToString;

  function stringToSpec(str) {
    var parts = str.split('-');

    if (parts.length !== 3) {
      throw new Error('Invalid KPI Set spec string: ' + str);
    }

    if (parts[2] !== KpiEngineEnum_1.KpiEngineSetKeyEnum.KEY_NORMAL && parts[2] !== KpiEngineEnum_1.KpiEngineSetKeyEnum.KEY_SIMULATION) {
      throw new Error('Invalid KPI Set spec string: ' + str);
    }

    return parts;
  }

  KpiSetSpec.stringToSpec = stringToSpec;
  /**
   * Converts name of KPI to snake case format.
   * @param s
   */

  function kpiNameToSnakeCase(s) {
    if (utils_1.Utils.isUndefined(s) || s.length === 0) {
      return s;
    }

    return utils_1.Utils.camelCaseToSnakeCase(s.replace('BM', 'Bm'));
  }

  KpiSetSpec.kpiNameToSnakeCase = kpiNameToSnakeCase;
})(KpiSetSpec = exports.KpiSetSpec || (exports.KpiSetSpec = {}));